import React from 'react';
import {useAppStore} from "../../../../../../GlobalStore/GlobalStore.ts";
import {writeSettings} from "../../../../../../Utils/db/users/userSettings/writeSettings.ts";
import ToggleSwitch from "../../Subcomponents/ToggleSwitch/ToggleSwitch.tsx";
import SettingRow from "../../Subcomponents/SettingRow/SettingRow.tsx";
import InfoButton from "../../Subcomponents/InfoButton/InfoButton.tsx";

interface ScrapeSettingsProps {}

const ScrapeSettings: React.FC<ScrapeSettingsProps> = () => {
    const userObj = useAppStore((state: any) => state.userObj);
    const { user } = userObj;
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { scrapeErrors, scrapeWarnings } = settingsObj;
    const setSettingsObj = useAppStore((state: any) => state.setSettingsObj);
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;

    const handleScrapeErrorsChange = async (newValue: boolean) => {
        setSettingsObj({ scrapeErrors: newValue });
        await writeSettings(user, { scrapeErrors: newValue }, environment);
    };

    const handleScrapeWarningsChange = async (newValue: boolean) => {
        setSettingsObj({ scrapeWarnings: newValue });
        await writeSettings(user, { scrapeWarnings: newValue }, environment);
    };

    return (
        <div className="space-y-4 pt-2">
            <div className="space-y-3">
                <SettingRow
                    label={
                        <div className="flex items-center space-x-1">
                            <p>Scrape Errors</p>
                            <InfoButton
                                tooltipId="scrape-errors-tooltip"
                                tooltipContent="Let the AI see error messages in files."
                            />
                        </div>
                    }
                    content={
                        <ToggleSwitch
                            enabled={scrapeErrors ?? false}
                            onChange={handleScrapeErrorsChange}
                        />
                    }
                />

                <SettingRow
                    label={
                        <div className="flex items-center space-x-1">
                            <p>Scrape Warnings</p>
                            <InfoButton
                                tooltipId="scrape-warnings-tooltip"
                                tooltipContent="Let the AI see warning messages in files."
                            />
                        </div>
                    }
                    content={
                        <ToggleSwitch
                            enabled={scrapeWarnings ?? false}
                            onChange={handleScrapeWarningsChange}
                        />
                    }
                />
            </div>
        </div>
    );
};

export default ScrapeSettings;
